import React from 'react';
import { useState, useEffect } from 'react';
import "./CustomSelect.css"

const CustomSelect = (props) => {
    let isRequied;
    let sizeClass;
    let typeInput = ""
    let checkValidation = true
    let newId = ""
    if(props.validation == undefined){

    }else if(props.validation == false){
        checkValidation = false
    }
    function enterValue(event){
        props.onChangeInput(event.target.value)
    }
   
    if(props.size == undefined){
        sizeClass = "bigInput";
    }else if(props.size == "small"){
        sizeClass = "smallInput";
    }else{
        sizeClass = "bigInput";
    }

    if(props.isRequied == undefined){
        isRequied = false
    }else{
        isRequied =true;
    }


    if(props.id != undefined){
        newId = props.id
    }
    

  
   
    


    return <>
    <div className='div_withTittle'>
    <div className='tittle'>
    <p className='tittle_forInput'>{props.title}</p>
    <p className={isRequied?'requied_forInput':'dontDisplay'}>{" *"}</p>
    </div>
    <div  className={'inputWithIcon ' + sizeClass}>

   
    <select id={newId}  onChange={(e)=>{enterValue(e)}}  title={props.hint?props.hint:""} className={'select_withTittle '}>
        {props.optionLabels?.map((opt)=>{
            return <option>{opt}</option>
        })}
    </select>
    {props.icon}
    </div>
  
    </div>
    </>;
    };

export default CustomSelect;
